// extracted by mini-css-extract-plugin
module.exports = {"root":"IconIncome_root__KFYZa"};